import React from 'react'
import './Home.css'
import Hero from '../Hero/Hero'
import Services from '../Services/Services'
import Process from '../Process/Process'
import Strategies from '../Strategies/Strategies'
import Banner from '../Banner/Banner'

const Home = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Banner />
      <Process />
      <Strategies />
       
       
    </div>
  )
}

export default Home
